import type { FiscalContext } from '../domain/fiscalTypes';
import { isBranchPvReady } from '../domain/fiscalTypes';

export type FiscalReadiness = {
  canEmitLegalInvoice: boolean;
  blockReason?: string;
  nextAction?: { label: string; route: 'FiscalHub' | 'ArcaIntegration'; tab?: 'status' | 'setup' | 'branches' };
};

export function showFiscalDevEnvironmentSelector(): boolean {
  const flag = (process.env.EXPO_PUBLIC_FISCAL_DEV_MODE ?? '').trim().toLowerCase();
  return flag === '1' || flag === 'true' || flag === 'yes';
}

export function resolveFiscalReadiness(
  ctx: FiscalContext | null | undefined,
  options?: { fiscalEnabledInPlan?: boolean; arcaIntegrationsEnabled?: boolean }
): FiscalReadiness {
  const fiscalEnabledInPlan = options?.fiscalEnabledInPlan !== false;
  const arcaEnabled = options?.arcaIntegrationsEnabled !== false;

  if (!fiscalEnabledInPlan || !arcaEnabled) {
    return {
      canEmitLegalInvoice: false,
      blockReason: 'La facturación electrónica no está incluida en tu plan.',
    };
  }

  const profile = ctx?.profile;
  if (!profile || profile.setupStatus !== 'validated') {
    return {
      canEmitLegalInvoice: false,
      blockReason: 'Activá la facturación electrónica para emitir comprobantes legales.',
      nextAction: { label: 'Ir a facturación', route: 'FiscalHub', tab: 'setup' },
    };
  }

  if (!isBranchPvReady(ctx)) {
    return {
      canEmitLegalInvoice: false,
      blockReason: 'Validá el punto de venta ARCA de esta sucursal.',
      nextAction: { label: 'Validar punto de venta', route: 'FiscalHub', tab: 'branches' },
    };
  }

  if (profile.environment === 'produccion') {
    return {
      canEmitLegalInvoice: true,
    };
  }

  return {
    canEmitLegalInvoice: true,
    blockReason: showFiscalDevEnvironmentSelector()
      ? undefined
      : 'Comprobantes de prueba, sin validez legal.',
  };
}
